import React, { Component } from 'react'
import TeachersPV from './TeachersPV'
import AuthA from '../../store/actions/AuthA'
import Papa from 'papaparse'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import moment from 'moment'
import {connect} from 'react-redux'

const _ = {
    sortBy: sortBy
}

class TeachersPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: '',
      fields: ['lastName', 'firstName', 'username', 'type', 'actions'],
      activePage: 1,
      itemPerPage: 10,
      selectedIndex: 0,
      column: null,
      direction: null,
      loaded: false,
      results: []
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.getTeachers = this.getTeachers.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleDataSave = this.handleDataSave.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  getTeachers() {
    axios.get(process.env.REACT_APP_URL+'/teachers?filter[where][active]=true', {
      params: {
        access_token: localStorage.getItem('token')
      }
    })
    .then(response => {
      this.setState({ data: response.data, loaded: true });
    });
  }

  isSearched(searchKey) {
    return function(item) {
      return (
        !searchKey ||
        item.firstName.toLowerCase().includes(searchKey.toLowerCase()) ||
        item.lastName.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handlePaginationChange(e, {activePage}){
    this.setState({
      activePage: activePage,
    });
  }

  handleFileChange(file) {
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: this.handleDataChange
    });
  }

  handleDataChange(results) {
    // this.handleDataSave(results.data);
    this.setState({results: results.data})
    console.log('Parsing complete:', results);
  }

  handleRowClick(teacher) {
    this.props.history.push(this.props.location.pathname+'/' + teacher.teacherId);
  }

  handleDataSave() {
    // const content = fileReader.result;
    const data = this.state.results;
    let parsedStudent = {};

    let i = 0;
    for (i = 0; i < data.length; i++) {
      parsedStudent = {
        firstName: data[i]['firstName'],
        middleName: data[i]['middleName'],
        lastName: data[i]['lastName'],
        gender: data[i]['gender'],
        birthDate: moment(data[i]['birthDate']),
        address: data[i]['address'],
        employmentType: data[i]['employmentType'],
        email: data[i]['email'],
        contactNumber: data[i]['contactNumber'],
        yearsOfTeaching: data[i]['yearsOfTeaching'],
        yearsOfTeachingSALIS: data[i]['yearsOfTeachingSALIS'],
        degreeEarned : data[i]['degreeEarned'],
        username: data[i]['username'],
        password: data[i]['password'],
        type: data[i]['type'],
        level: data[i]['level']
      };
      const url = process.env.REACT_APP_URL+'/teachers';
      axios
        .request({
          method: 'post',
          url: url,
          data: parsedStudent,
          params: {
            access_token: localStorage.getItem('token')
          }
        })
        .then(response => {this.getTeachers()})
        .catch(err => console.log(err));
        // window.location.reload()
    }
  }

  handleSubmit(data) {
    const url = process.env.REACT_APP_URL+'/teachers';
    axios
      .request({
        method: 'post',
        url: url,
        data: data,
        params: {
          access_token: localStorage.getItem('token')
        }
      })
      .then(response => {this.getTeachers()})
      .catch(err => console.log(err));
  }

  handleUpdate(data,id) {
    const url = process.env.REACT_APP_URL+'/teachers/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data,
        params: {
          access_token: localStorage.getItem('token')
        }
      })
      .then(response => {this.getTeachers()})
      .catch(err => console.log(err));
  }

  handleDelete(id) {
    const url = process.env.REACT_APP_URL+'/teachers/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false},
        params: {
          access_token: localStorage.getItem('token')
        }
      })
      .then(response => {this.getTeachers()})
      .catch(err => console.log(err));
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup / Teachers'});
    this.getTeachers();
  }

  render() {
    return (
      <TeachersPV
        auth={this.props.auth}
        userType={this.props.userType}
        activePage={this.state.activePage}
        itemPerPage={this.state.itemPerPage}
        column={this.state.column}
        direction={this.state.direction}
        data={this.state.data}
        searchKey={this.state.searchKey}
        fields={this.state.fields}
        loaded={this.state.loaded}
        isSearched={this.isSearched}
        onSearchChange={this.onSearchChange}
        handleSort={this.handleSort}
        handlePaginationChange={this.handlePaginationChange}
        handleDataSave={this.handleDataSave}
        handleFileChange={this.handleFileChange}
        handleRowClick={this.handleRowClick}
        handleSubmit={this.handleSubmit}
        handleUpdate={this.handleUpdate}
        handleDelete={this.handleDelete}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TeachersPC);
